<template>
  <q-dialog
    v-model="shown"
  >
    <q-card>
      <q-card-section>
        <div class="row justify-between">
          <div class="text-h5">
            Payment Connector Actions
          </div>
          <q-btn
            flat
            round
            dense
            icon="close"
            @click="close"
          />
        </div>
      </q-card-section>

      <q-card-section>
        <q-inner-loading :showing="performingAction" />
        <div class="row q-mb-sm">
          <div class="text-h6 q-mr-sm">
            Maintenance
          </div>
          <q-icon
            size="md"
            name="engineering"
          />
        </div>
        <div class="row justify-around">
          <q-btn
            v-if="hasAction('logon')"
            label="Log On"
            color="green"
            icon="login"
            :disable="performingAction"
            @click="performAction('logon')"
          />
          <q-btn
            v-if="hasAction('logoff')"
            label="Log Off"
            color="red"
            icon="logout"
            :disable="performingAction"
            @click="performAction('logoff')"
          />
        </div>
        <div class="row q-mt-md q-mb-sm">
          <div class="text-h6 q-mr-sm">
            Printing
          </div>
          <q-icon
            size="md"
            name="print"
          />
        </div>
        <div class="row q-mb-xs">
          <q-btn
            v-if="hasAction('print_totals_report')"
            class="full-width"
            color="secondary"
            label="Print Totals Report"
            icon="summarize"
            :disable="performingAction"
            @click="performAction('print_totals_report')"
          />
        </div>
        <div class="row q-mb-xs">
          <q-btn
            v-if="hasAction('print_detailed_report')"
            class="full-width"
            color="accent"
            label="Print Detailed Report"
            icon="query_stats"
            :disable="performingAction"
            @click="performAction('print_detailed_report')"
          />
        </div>
        <div class="row q-mb-xs">
          <q-btn
            v-if="hasAction('print_last_receipt')"
            class="full-width"
            color="primary"
            label="Print Last Receipt"
            icon="receipt"
            :disable="performingAction"
            @click="performAction('print_last_receipt')"
          />
        </div>
        <div class="row q-mb-xs">
          <q-btn
            v-if="hasAction('settle')"
            class="full-width"
            color="info"
            label="Settle"
            icon="checkbook"
            :disable="performingAction"
            @click="performAction('settle')"
          />
        </div>
        <div class="row q-mb-xs">
          <q-btn
            v-if="hasAction('balance')"
            class="full-width"
            color="dark"
            label="Balance Request"
            icon="account_balance"
            :disable="performingAction"
            @click="performAction('balance')"
          />
        </div>
        <div class="row q-mb-xs">
          <q-btn
            v-if="hasAction('tip_adjust') && order"
            class="full-width"
            color="warning"
            label="Tip Adjustment"
            icon="build"
            :disable="performingAction"
            @click="() => $refs.tipAdjust.show()"
          />
        </div>
      </q-card-section>
    </q-card>
    <tip-adjust-dialog
      v-if="order"
      ref="tipAdjust"
      :order="order"
    />
  </q-dialog>
</template>

<script>

import Order from 'src/models/order/Order'
import TipAdjustDialog from 'src/modules/register/components/payment/TipAdjustDialog'

export default {
  name: 'ConnectorActionDialog',
  components: {
    TipAdjustDialog
  },
  props: {
    order: {
      type: Order,
      required: false,
      default: null
    }
  },
  data () {
    return {
      shown: false,
      performingAction: false
    }
  },
  context: ['currentRegisterClient'],
  computed: {
    availableActions () {
      return this.currentRegisterClient?.registerStation?.paymentConnectorMaintenanceOptions || []
    }
  },
  methods: {
    close () {
      this.shown = false
    },
    show () {
      this.shown = true
    },
    hasAction (name) {
      return _.includes(this.availableActions, name)
    },
    async performAction (name, options = {}) {
      this.performingAction = true

      try {
        await this.$paymentConnectorHandler.performMaintenanceAction(this.currentRegisterClient, name, options)
      } catch (exception) {
        this.$q.notify({
          message: 'Failed to perform action: ' + exception.message,
          color: 'negative',
          position: 'top'
        })
      }

      this.performingAction = false
    }
  }
}

</script>
